import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigTwinSettings } from "./app-settings-config-twin";

export interface IConfigTwinInputState {
  showModal: boolean;
  editingTwinId: string;
}

export interface IConfigTwinInputProps {
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigTwinInput extends PureComponent<IConfigTwinInputProps, IConfigTwinInputState> {
  formInputName = ["apiConfig", "twinSettingsId"];

  constructor(props: IConfigTwinInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingTwinId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingTwinId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingTwinId: id, showModal: true });
  };

  render(): ReactNode {
    // No "Default" option — a KuikAgents Integration has no built-in default (it
    // requires URL + access secret + identity secret). The dropdown starts empty with
    // the "Choose Configuration" placeholder until the user picks/creates a real one.
    //
    // The section heading and its copy belong to the pane's category registry now, so this
    // renders the row only — it used to bring its own `ConfigSection` because it was the
    // one setting the web pane did not wrap.
    const options = this.props.commonSettings.twinSettings || [];
    return (
      <>
        <ConfigTwinSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingTwinId={this.state.editingTwinId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          allowClear
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          dropdownTestId="appSettingsTwinDropdown"
          addNewTestId="appSettingsTwinAddNewButton"
          editTestId="appSettingsTwinEditButton"
        />
      </>
    );
  }
}
